export const DEFAULT_TOURISTS = { rooms: [{ adults: 2, childrenAges: [] }] };
export const DEFAULT_INFANT_AGE = 1;
export const DEFAULT_KID_AGE = 5;
